import React, { useContext } from "react";
import { Button, Form, Input, Typography } from "antd";
import AuthContext from "../../../context/AuthContext";
import Styles from "./Login.module.css";

const { Paragraph, Title } = Typography;

export const LoginForm = () => {
  const {
    username,
    password,
    onChangeUsername,
    onChangePassword,
    handleLogin,
    openCloseModalResetPassword,
  } = useContext(AuthContext);

  return (
    <section className={Styles.panel} aria-labelledby="login-title">
      <div className={Styles.intro}>
        <span className={Styles.eyebrow}>Quattro Support</span>
        <Title id="login-title" level={1} className={Styles.title}>Welcome back</Title>
        <Paragraph className={Styles.description}>
          Sign in to manage projects, track requests, and get help from the Quattro team.
        </Paragraph>
      </div>

      <Form layout="vertical" onFinish={handleLogin} requiredMark="optional" className={Styles.form}>
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Enter your username" }]}
        >
          <Input
            autoComplete="username"
            name="username"
            placeholder="Enter your username…"
            size="large"
            spellCheck={false}
            value={username}
            onChange={(event) => onChangeUsername(event.target.value)}
          />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Enter your password" }]}
        >
          <Input.Password
            autoComplete="current-password"
            name="password"
            placeholder="Enter your password…"
            size="large"
            value={password}
            onChange={(event) => onChangePassword(event.target.value)}
          />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          className={Styles.login_form__signin}
        >
          Sign in
        </Button>
      </Form>

      <Button
        type="link"
        className={Styles.forgot}
        onClick={() => openCloseModalResetPassword(true)}
      >
        Forgot your password?
      </Button>
    </section>
  );
};
